// Display only. Biological selection and comparison are owned by the backend.
export const SEA_BASS_RANKING_POLICY = "sea_bass_raw_1";
export const MACKEREL_RANKING_POLICY = "mackerel_regional_raw_1";
export const isBackendPeriodPolicy = (policy) => [SEA_BASS_RANKING_POLICY, MACKEREL_RANKING_POLICY, "raw_modeled_period_1"].includes(policy);
export const graphScore = (value) =>
  Number.isFinite(value?.rawScore) ? value.rawScore : value?.score;

export const normalizeModeledPeriod = (value, normalizeScore, normalizeConfidence) => {
  if (!value || !["period", "hour"].includes(value.kind)) return null;
  const timestamps = Array.isArray(value.point_timestamps)
    ? value.point_timestamps.filter((stamp) => typeof stamp === "string" && Number.isFinite(Date.parse(stamp)))
    : [];
  const mean = normalizeScore(value.mean_opportunity);
  const peak = normalizeScore(value.peak_opportunity);
  if (!mean || !peak || !timestamps.length || !Number.isFinite(Date.parse(value.start)) || !Number.isFinite(Date.parse(value.end))) return null;
  return {
    kind: value.kind, startTimestamp: value.start, endTimestamp: value.end,
    rankingValue: graphScore(mean), meanOpportunity: mean, peakOpportunity: peak,
    peakTimestamp: value.peak_time, pointTimestamps: timestamps,
    confidence: normalizeConfidence(value.confidence), safetyEligible: value.safety_eligible === true,
    comparison: ["exact_tie", "similar", "higher", "single_period"].includes(value.comparison) ? value.comparison : "single_period",
  };
};

export const backendDayPresentation = (day, points) => ({
  ...day, points, strongest: day.modeledPeriod,
  hasFlatOpportunity: ["exact_tie", "similar"].includes(day.modeledPeriod?.comparison),
  isBestModeledPeriod: day.isBestModeledPeriod === true,
});
